import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { StatService } from '@call-tracking/services/StatService';

export const table = snakeStore({
  state: {
    [SORT_COLUMN]: 'called_at',
    [SORT_DIRECTION]: 'desc'
  },
  actions: {
    getData: (_, params) => StatService.getDetailed(params)
  }
});
